var _mask, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInactivePage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_198_150",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H14V14H0V0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V-1H-1V0H0ZM14 0H15V-1H14V0ZM14 14V17H15V14H14ZM0 14H-1V17H0V14ZM0 0V1H14V0V-1H0V0ZM14 0H13V14H14H15V0H14ZM14 14V11H0V14V17H14V14ZM0 14H1V0H0H-1V14H0Z",
    fill: "#202D66",
    mask: "url(#path-1-inside-1_198_150)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivePage);
export default __webpack_public_path__ + "static/media/inactive-page.cd7c4d35962a3591b0b0c73f513e73a4.svg";
export { ForwardRef as ReactComponent };